<div #navbarWrapper class="h-100">
  <ng-container *ngIf="headerBgConfig | async as bgConfig">
    <nav class="sidebar">
      <div class="sidebar-logo">
        <a [routerLink]="logoLink" title="inicio">
          <app-image
            [src]="brandLogoToShow$ | async"
            [defaultImage]="'/assets/nolia/logo/isotipo.png'"
          ></app-image>
        </a>
      </div>

      <div class="nav-items">
        <ng-container *ngFor="let option of options">
          <a [routerLink]="option.link"
             class="nav-item"
             routerLinkActive="active"
             [title]="option.title | translate"
             [style.--active-color]="bgConfig.mainColor"
             [attr.data-tour]="option.slug === 'training' ? 'training-menu-item' : null">
            <!-- Icono para Clases -->
            <svg *ngIf="option.slug === 'classes'" class="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
            </svg>
            <!-- Icono para Colegios -->
            <svg *ngIf="option.slug === 'colegios'" class="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
            </svg>
            <!-- Icono para Buscador -->
            <svg *ngIf="option.slug === 'search'" class="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
            <!-- Icono para Formaciones (imagen SVG) -->
            <img *ngIf="option.slug === 'training'" class="nav-icon" [src]="option.icon" alt="" />
            <span class="nav-text font-primary--eb">{{ option.title | translate }}</span>
          </a>
        </ng-container>
      </div>

      <div class="sidebar-footer">
        <a href="#" class="nav-item" (click)="logoutHandler()" [title]="'sidebar.sign-out' | translate">
          <svg class="nav-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
          </svg>
          <span class="nav-text font-primary--eb">{{ 'sidebar.sign-out' | translate }}</span>
        </a>
      </div>
    </nav>
  </ng-container>
</div>
